import { useSelector } from "react-redux";
import { mainStateSelector, MAIN_STATE_KEY } from "./main-reducer";
import {
  GENERAL_STATE_KEY,
  generalStateSelector,
} from "../redux/general/general-reducer";
import { Locale } from "../language";

class MainHelperClass {
  getMasterDataByCode = (code: string) => {
    try {
      const currentLang = useSelector(
        generalStateSelector(GENERAL_STATE_KEY.LOCALE),
      );
      const masterdata = useSelector(
        mainStateSelector(MAIN_STATE_KEY.MASTER_DATA),
      );
      if (masterdata) {
        const val =
          currentLang === Locale.EN
            ? masterdata.codes[code].classificationNameEn
            : masterdata.codes[code].classificationNameTh;
        return val;
      } else {
        return code;
      }
    } catch (error) {
      return code;
    }
  };

  getMasterDataByScheme = (scheme: string) => {
    try {
      const masterdata = useSelector(
        mainStateSelector(MAIN_STATE_KEY.MASTER_DATA),
      );
      if (masterdata) {
        const val = masterdata.schemes[scheme];
        return val;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  };
}

export const MainHelper = new MainHelperClass();
